import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import ArrowIcon from "../assets/images/slide-arrow.svg";

const ProjectSlider = ({ slides }) => {
  const swiperRef = useRef(null);
  const [activeRealIndex, setActiveRealIndex] = useState(0);

  return (
    <div className="projects-slider-wrapper">
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setActiveRealIndex(swiper.realIndex)}
        modules={[Navigation, Autoplay]}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-wrapper">
              <div className="left-part">
                <h4>{slide.title}</h4>
                <span className="left-part__subtitle">{slide.subTitle}</span>
                {/* <span className="left-part__keypoint">{slide.keyPoint}</span> */}
                <p className="left-part__review">{slide.description}</p>
                {/* <div className="left-part__person">
                  <img src={slide.personImage?.url} alt="avatar" />
                  <div className="left-part__person-info">
                    <span className="name">{slide.personName}</span>
                    <span className="position">{slide.positionOfPerson}</span>
                  </div>
                </div> */}
              </div>
              <div className="right-part">
                <img src={slide.mainImage?.url} alt="company" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="custom-slider-control">
        <button onClick={() => swiperRef.current?.slidePrev()}>
          <img src={ArrowIcon} alt="prev" className="arrow arrow--prev" />
        </button>

        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => swiperRef.current?.slideToLoop(index)}
            className={`pagination-bullet ${
              index === activeRealIndex ? "active" : ""
            }`}
          >
            {`0${index + 1}`}
          </button>
        ))}

        <button onClick={() => swiperRef.current?.slideNext()}>
          <img src={ArrowIcon} alt="next" className="arrow arrow--next" />
        </button>
      </div>
    </div>
  );
};

export default ProjectSlider;
